export interface BoxRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function computeContainRect(box: BoxRect, imgW: number, imgH: number): BoxRect {
  const imgAspect = imgW / imgH;
  const boxAspect = box.width / box.height;

  let fitW: number;
  let fitH: number;
  if (imgAspect > boxAspect) {
    fitW = box.width;
    fitH = box.width / imgAspect;
  } else {
    fitH = box.height;
    fitW = box.height * imgAspect;
  }

  return {
    left: box.left + (box.width - fitW) / 2,
    top: box.top + (box.height - fitH) / 2,
    width: fitW,
    height: fitH,
  };
}
